import {
  FIRST_QUIZ_RESULTS_CTA_ACTIONS,
  GROWTH_RECEIPT_EVENTS,
  sendGrowthReceipt,
} from '../../utils/growth-receipt';

/*
 * The block's two signals, both fire-and-forget:
 * - the growth receipt { event: "first_quiz_results_cta", action } through the
 *   app's one receipt path, utils/growth-receipt.js (POST
 *   /qlearn/api/growth/receipt; the server takes the user from the session and
 *   logs an identifier-free line). Never awaited: a 404, a 429, any other
 *   status or a network failure never reaches the page;
 * - a GTM dataLayer event first_quiz_results_cta with `action` only.
 */
export const FIRST_QUIZ_RESULTS_CTA = GROWTH_RECEIPT_EVENTS.FIRST_QUIZ_RESULTS_CTA;

export const FIRST_QUIZ_ACTIONS = Object.freeze({
  SHOWN: 'shown',
  REMIND_ME: 'remind_me',
  CALENDAR: 'calendar',
  START_NEXT: 'start_next',
  DISMISS: 'dismiss',
});

// The server's allowlist, as the receipt helper holds it.
const ALLOWED = new Set(FIRST_QUIZ_RESULTS_CTA_ACTIONS);

// Started on the next microtask, inside the chain, so neither a throw nor a
// rejection can reach the click (the helper does neither today: it resolves
// to true or false).
const sendReceipt = (action) => {
  Promise.resolve(action)
    .then((value) => sendGrowthReceipt(FIRST_QUIZ_RESULTS_CTA, value))
    .catch(() => false);
};

const pushDataLayer = (action) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: FIRST_QUIZ_RESULTS_CTA, action });
  } catch {
    // A consent manager's throwing push stays out of the click.
  }
};

/** Both signals for one block action. Actions outside the contract send nothing. */
export const trackFirstQuizCta = (action) => {
  if (!ALLOWED.has(action)) return;
  sendReceipt(action);
  pushDataLayer(action);
};
